<template>
  <base-container ref="container" :isLoading="isLoading">
    <ArtisanGrid
      ref="doctor"
      metaKey="BasisDoctorInfo"
      @createUser="createUser"
      @syncDoctor="syncDoctor"
      :metaInited="metaInited"
    >
      <template #sexForm="{ row }">
        <el-radio-group v-model="row.sex">
          <el-radio label="男">男</el-radio>
          <el-radio label="女">女</el-radio>
        </el-radio-group>
      </template>
    </ArtisanGrid>

    <artisan-dialog
      title="生成用户"
      :visible.sync="isShow"
      :isLoading="loading"
      width="40%"
      height="40%"
    >
      <el-form
        ref="form"
        style="padding-top: 15px"
        label-width="150px"
        :model="data"
      >
        <el-col :span="24">
          <el-form-item prop="role" label="请选择用户角色">
            <el-select
              multiple
              v-model="data.role"
              size="mini"
              style="width: 80%"
              placeholder="请选择用户角色"
            >
              <el-option
                v-for="item in roles"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>

      <template #footer>
        <el-button type="primary" size="mini" @click="selectRole()"
          >确认</el-button
        >
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { createUser } from "@/api/sys/user";
import { syncDoctor } from "@/api/basis/doctor";
import { loadEnums } from "@/api/sys/dicType";
import BaseContainer from "../../components/BaseContainer.vue";
export default {
  components: { BaseContainer },
  data() {
    return {
      isLoading: false,
      loading: false,
      roles: [],
      isShow: false,
      role: "",
      data: {},
    };
  },
  created() {
    loadEnums("SysRoleInfo").then((res) => {
      this.dic = res.data.data;
      this.roles = this.dic.SysRoleInfo;
    });
  },
  methods: {
    metaInited(option) {
      let sexCol = option.columns.find((c) => c.code == "sex");
      if (sexCol) sexCol.isSlot = true;
    },
    syncDoctor() {
      this.$refs.container.confirm({ msg: "确认同步医生信息？" }).then(() => {
        this.isLoading = true;
        syncDoctor()
          .then(() => {
            this.isLoading = false;
            this.$message({
              type: "success",
              message: "同步成功！",
            });
            this.$refs.doctor.reload();
          })
          .catch(() => {
            this.isLoading = false;
          });
      });
    },
    selectRole() {
      this.loading = true;
      if (this.data.role) {
        this.data.roles = this.data.role.join(",");
      }
      this.$confirm("确认生成用户？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          createUser(this.data)
            .then((res) => {
              this.$message({
                message: "生成成功！",
                type: "success",
              });
              this.isShow = false;
              this.loading = false;
            })
            .catch(() => {
              this.isShow = false;
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    createUser(row) {
      this.isShow = true;
      this.data = row;
    },
  },
};
</script>

<style></style>
